<template>
  <div class="snippet-template-content main-content wide">
    <div
      v-if="showTitle"
      class="wrap"
    >
      <h1 :style="{'text-align': pageTitlePosition}">{{ pageTitle }}</h1>

      <div
        v-if="showDescription"
        v-dompurify-html="pageDescription"
        class="description"
      />
    </div>

    <div
      v-for="(section, index) in sections"
      :key="index"
    >
      <thank-you
        v-if="section.type === 'thankYou'"
        :section="section"
      />
      <wide-image
        v-if="section.type === 'wideImage'"
        :title="section.title"
        :description="section.description"
        :desktop-image="section.desktopImage"
        :mobile-image="section.mobileImage"
        :mobile-color-code="section.mobileColorCode"
      />

      <voucher
        v-if="section.type === 'voucher'"
        :section="section"
      />

      <terms
        v-if="section.type === 'termsAndConditions'"
        :title="section.title"
        :text="section.text"
        :note-text="section.noteText"
      />

      <two-columns-text
        v-if="section.type === 'twoColumnsText'"
        :section="section"
      />

      <custom-image
        v-if="section.type === 'mainImage'"
        :largetext="section.largeText"
        :small-text="section.smallText"
        :desktop-image="section.desktopImage"
        :tablet-image="section.tabletImage"
        :mobile-image="section.mobileImage"
      />

      <centered-text
        v-if="section.type === 'centredText'"
        :large-text="section.largeText"
        :small-text="section.smallText"
      />

      <two-columns
        v-if="section.type === 'twoColumns'"
        :section="section"
      />

      <four-columns
        v-if="section.type === 'fourColumns'"
        :section="section"
      />

      <text-and-video
        v-if="section.type === 'textAndVideo'"
        :section="section"
      />

      <text-and-counter
        v-if="section.type === 'textAndCounter'"
        :section="section"
      />

      <small-form
        v-if="section.type === 'textAndShortForm'"
        :namespace="section.namespace"
        :section-data="section"
      />

      <large-form
        v-if="section.type === 'largeSubscribeForm'"
        :namespace="section.namespace"
        :section-data="section"
      />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import isUndefined from 'lodash-es/isUndefined'
  import isNull from 'lodash-es/isNull'

  export default {
    components: {
      'four-columns': () => import(/* webpackChunkName: "four-columns" */ 'components/SnippetTemplate/Items/FourColumns'),
      'two-columns': () => import(/* webpackChunkName: "two-columns" */ 'components/SnippetTemplate/Items/TwoColumns'),
      'two-columns-text': () => import(/* webpackChunkName: "two-columns-text" */ 'components/SnippetTemplate/Items/TwoColumnsText'),
      'centered-text': () => import(/* webpackChunkName: "centered-text" */ 'components/SnippetTemplate/Items/CenteredText'),
      'custom-image': () => import(/* webpackChunkName: "custom-image" */ 'components/SnippetTemplate/Items/CustomImage'),
      'wide-image': () => import(/* webpackChunkName: "wide-image" */ 'components/SnippetTemplate/Items/WideImage'),
      'text-and-video': () => import(/* webpackChunkName: "text-and-video" */ 'components/SnippetTemplate/Items/TextAndVideo'),
      'text-and-counter': () => import(/* webpackChunkName: "text-and-counter" */ 'components/SnippetTemplate/Items/TextAndCounter'),
      'small-form': () => import(/* webpackChunkName: "small-form" */ 'components/SnippetTemplate/Items/SmallForm'),
      'large-form': () => import(/* webpackChunkName: "large-form" */ 'components/SnippetTemplate/Items/LargeForm'),
      'terms': () => import(/* webpackChunkName: "terms" */ 'components/SnippetTemplate/Items/Terms'),
      'voucher': () => import(/* webpackChunkName: "voucher" */ 'components/SnippetTemplate/Items/Voucher'),
      'thank-you': () => import(/* webpackChunkName: "thank-you" */ 'components/SnippetTemplate/Items/ThankYou'),
    },
    computed: {
      ...mapState('snippetTemplate', [
        'sections',
        'pageTitle',
        'pageDescription',
        'pageTitlePosition'
      ]),
      showTitle () {
        return !isUndefined(this.pageTitle) && !isNull(this.pageTitle) && this.pageTitle.trim() !== ''
      },
      showDescription () {
        return !isUndefined(this.pageDescription) && !isNull(this.pageDescription) && this.pageDescription.trim() !== ''
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .snippet-template-content {

    h1 {
      margin: 19px 23px 20px;
      font-size: em(32);
      line-height: 40px;
      font-weight: 400;
      word-wrap: break-word;

      @include bp-mf-tablet {
        margin: 34px 26px 32px;
        font-size: em(40);
        line-height: 50px;
      }
    }

    .description {
      margin: 0 23px;
      font-size: em(16);
      line-height: 18px;
      text-align: justify;

      @include bp-mf-tablet {
        margin: 0 auto;
        max-width: 640px;
      }

      ::v-deep p {
        margin: 0 0 10px;
      }

      ::v-deep a {
        color: $blue-medium;
      }
    }
  }
</style>
